var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.15292 0.00172825C1.03041 0.0473201 0 0.987485 0 2.25414V17.7461C0 19.435 1.8328 20.5431 3.27194 19.7246L16.8896 11.9786C18.3701 11.1364 18.3701 8.86386 16.8896 8.02167L3.27194 0.275671C2.91216 0.0710465 2.52709 -0.013469 2.15292 0.00172825Z",
    fill: "#9277FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIcon);
export default __webpack_public_path__ + "static/media/play-icon.6eec7f8dc6d121ad1df2b412a51b26e7.svg";
export { ForwardRef as ReactComponent };